import MyTest from './MyTest.vue';

export default MyTest;
